<!-- 基础配置管理 -->
<template>
    <div class="admin_home">
        <admin-home></admin-home>
    </div>
</template>

<script>
import AdminHome from './AdminHome/AdminHome'

export default {
    name: 'admin',
    data () {
        return {
        };
    },

    components: { AdminHome },
}

</script>

<style lang="less" scoped>
.admin_home{
    margin: 10px;
    height: calc(100% - 50px);
}
</style>
